import { setAddMany, setToString } from './set.utils.js';

/**
 * Conditionally joins CSS class names together.
 */ function classNames(outputClassNames, ...args) {
    args.forEach((arg)=>{
        if (arg && typeof arg === 'object') {
            if (Array.isArray(arg)) {
                setAddMany(outputClassNames, classNames(outputClassNames, ...arg));
            } else {
                Object.keys(arg).forEach((key)=>{
                    if (arg[key]) {
                        outputClassNames.add(key);
                    }
                });
            }
        } else if (arg) {
            outputClassNames.add(arg);
        }
    });
    return outputClassNames;
}
function className(...args) {
    const outputClassNames = new Set();
    return setToString(classNames(outputClassNames, ...args), ' ');
}

export { className, classNames };
